import React, { useEffect, useState } from "react";
import Button from "./Button";
import Modal from "../../../../../components/ui/Modal/Modal";
import LotModal from "../Section/LotStockInformation/LotModal";

const TableInformation = (props) => {
  const {
    title,
    margin,
    disabledButton,
    buttonColor,
    colorTextButton,
    lotButton,
    productData,
    stockSummaryData,
    productLotQntData,
    prodId,
  } = props;

  const [triggerCloseLotModal, setTriggerCloseLotModal] = useState(false);

  useEffect(() => {
    if (triggerCloseLotModal === true) {
      setTriggerCloseLotModal(false);
    }
  }, [triggerCloseLotModal]);

  return (
    <div className={`${margin}`}>
      <div className="border-primary-blue py-2 px-4 flex justify-between bg-primary-blue">
        <h1 className="text-white flex items-center">{title}</h1>
        <div className="flex">
          <Modal
            maxWidth="max-w-[45rem]"
            padding="px-0 py-2"
            hasCancel={false}
            hasSubmit={false}
            description={
              <LotModal
                prodId={prodId}
                productData={productData}
                setTriggerCloseLotModal={setTriggerCloseLotModal}
              />
            }
            triggerClose={triggerCloseLotModal}
          >
            <Button
              onClick={lotButton}
              width={`w-36`}
              margin={`mr-2`}
              disabled={disabledButton}
              titleButton={`LOT 재고 정보`}
              backgroundColor={buttonColor}
              textColor={colorTextButton}
              padding={"py-0.5"}
            />
          </Modal>

          <Button
            titleButton={`현재 재고수량 산출법`}
            width={`w-36`}
            backgroundColor={`bg-white`}
            padding={"py-0.5"}
          />
        </div>
      </div>
      <div>
        <table className="min-w-full">
          <thead className="bg-input-grey">
            <tr>
              <th
                className="py-2.5 px-4 border border-disable-grey text-black"
                colSpan={5}
              >
                A. 총 입고수량
              </th>
              <th
                className="py-2 px-4 border border-disable-grey text-black"
                colSpan={5}
              >
                B. 총 출고수량
              </th>
              <th
                className="py-2 px-4 border border-disable-grey text-black"
                colSpan={2}
              >
                C. 총 조정수량
              </th>
              <th
                className="py-2 px-6 border border-disable-grey text-black"
                rowSpan={2}
              >
                현재 재고수량
              </th>
            </tr>
            <tr className="text-center text-[10px]">
              <td className="py-1.5 w-24 px-2 border border-disable-grey text-black">
                스마트팩토리 연동
              </td>
              <td className="py-1.5 px-1.5 w-24 border border-disable-grey text-black">
                <p>수동 등록</p>
                <p>(LOT 신규 생성)</p>
              </td>
              <td className="px-2 w-[78px] border border-disable-grey text-black">
                교환(재입고)
              </td>
              <td className="px-2 w-[78px] border border-disable-grey text-black">
                반품(재입고)
              </td>
              <td className=" px-2 w-[78px] border border-disable-grey text-black">
                <p>불량재고 접수</p>
                <p>(폐기예정)</p>
              </td>

              <td className="px-2 w-[82px] border border-disable-grey text-black">
                수동(원데이몰)
              </td>
              <td className="px-2 w-[76px] border border-disable-grey text-black">
                수동(재고)
              </td>
              <td className="px-2 w-[76px]  border border-disable-grey text-black">
                자동(재고)
              </td>
              <td className="px-2 w-20 border border-disable-grey text-black">
                <p>기타 출고</p>
                <p>(QR 스캔)</p>
              </td>
              <td className="px-2 w-16 border border-disable-grey text-black">
                <p>불량재고</p>
                <p>(교환)</p>
              </td>

              <td className="px-2 border border-disable-grey text-black">
                (+) 조정수량
              </td>
              <td className="px-2 border border-disable-grey text-black">
                (-) 조정수량
              </td>
            </tr>
          </thead>
          <tbody>
            <tr className="text-center">
              <td className="p-2 border border-[#dddddd]">
                {stockSummaryData?.stockQnt?.smart ?? "-"}
              </td>
              <td className="p-2 border border-[#dddddd]">
                {stockSummaryData?.stockQnt?.manual ?? "-"}
              </td>
              <td className="p-2 border border-[#dddddd]">
                {stockSummaryData?.stockQnt?.exchange ?? "-"}
              </td>
              <td className="p-2 border border-[#dddddd]">
                {stockSummaryData?.stockQnt?.return ?? "-"}
              </td>
              <td className="p-2 border border-[#dddddd]">
                {stockSummaryData?.stockQnt?.defective ?? "-"}
              </td>
              <td className="p-2 border border-[#dddddd]">
                {stockSummaryData?.shipmentQnt?.manual ?? "-"}
              </td>
              <td className="p-2 border border-[#dddddd]">
                {stockSummaryData?.shipmentQnt?.manual ?? "-"}
                {/* one day mall needs to be fixed */}
              </td>
              <td className="p-2 border border-[#dddddd]">
                {stockSummaryData?.shipmentQnt?.auto ?? "-"}
              </td>
              <td className="p-2 border border-[#dddddd]">
                {stockSummaryData?.shipmentQnt?.qr ?? "-"}
              </td>
              <td className="p-2 border border-[#dddddd]">
                {stockSummaryData?.shipmentQnt?.exchange ?? "-"}
              </td>
              <td className="p-2 border border-[#dddddd]">
                {stockSummaryData?.adjustedQnt?.increase ?? "-"}
              </td>
              <td className="p-2 border border-[#dddddd]">
                {stockSummaryData?.adjustedQnt?.decrease ?? "-"}
              </td>
              <td className="p-2 border border-[#dddddd] text-[#e80000]">
                {productLotQntData?.currentStockQnt}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableInformation;
